import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import PersonSearchOutlinedIcon from '@mui/icons-material/PersonSearchOutlined';
import PauseOutlinedIcon from '@mui/icons-material/PauseOutlined';
import type { ObjectDetailsHeaderAction } from 'framework/ViewTypes/contentLayout';
import type { RecruitmentPool, RecruitmentPoolStatus } from '../../types';
import { RECRUITMENT_POOL_STATUS } from '../../constants';

export const getRecruitmentPoolHeaderActions = (
  recruitmentPool: RecruitmentPool,
  canUpdate: boolean,
  canSource: boolean,
  onEdit: () => void,
  onTransit: (status: RecruitmentPoolStatus) => void,
  onSourcing: () => void,
): ObjectDetailsHeaderAction[] => {
  const actions: ObjectDetailsHeaderAction[] = [];

  if (recruitmentPool.status === RECRUITMENT_POOL_STATUS.CLOSED) {
    return actions;
  }

  actions.push({
    id: 'edit-recruitment-pool',
    label: 'Edit recruitment pool',
    icon: <EditOutlinedIcon />,
    variant: 'outlined',
    tooltip: 'Edit recruitment pool',
    disabled: !canUpdate,
    onClick: onEdit,
  });

  if (recruitmentPool.status === RECRUITMENT_POOL_STATUS.ACTIVE) {
    actions.push({
      id: 'pause-recruitment-pool',
      label: 'Pause recruitment pool',
      icon: <PauseOutlinedIcon />,
      variant: 'outlined',
      tooltip: 'Pause recruitment pool',
      disabled: !canUpdate,
      onClick: () => onTransit(RECRUITMENT_POOL_STATUS.PAUSED),
    });
  }

  if (recruitmentPool.status === RECRUITMENT_POOL_STATUS.PAUSED) {
    actions.push(
      {
        id: 'activate-recruitment-pool',
        label: 'Activate recruitment pool',
        icon: <PlayArrowIcon />,
        variant: 'outlined',
        tooltip: 'Activate recruitment pool',
        disabled: !canUpdate,
        onClick: () => onTransit(RECRUITMENT_POOL_STATUS.ACTIVE),
      },
      {
        id: 'close-recruitment-pool',
        label: 'Close recruitment pool',
        icon: <DoDisturbIcon />,
        variant: 'outlined',
        color: 'error',
        tooltip: 'Close recruitment pool',
        disabled: !canUpdate,
        onClick: () => onTransit(RECRUITMENT_POOL_STATUS.CLOSED),
      },
    );
  }

  actions.push({
    id: 'link-recruitment-pool',
    label: 'Manage positions fill requests',
    icon: <LinkOutlinedIcon />,
    variant: 'outlined',
    tooltip: 'Manage positions fill requests',
    disabled: true,
    onClick: () => {},
  });

  if (recruitmentPool.status === RECRUITMENT_POOL_STATUS.ACTIVE) {
    actions.push({
      id: 'sourcing-recruitment-pool',
      label: 'Sourcing candidates',
      icon: <PersonSearchOutlinedIcon />,
      variant: 'outlined',
      tooltip: 'Sourcing',
      disabled: !canSource,
      onClick: onSourcing,
    });
  }

  return actions;
};
